import { t } from "@travily/i18n";
import { Illustration } from "@ui/components/Illustration";
import { ListingCardAdapter, type ListingCardListing } from "@/components/ListingCard/ListingCardAdapter";
import { ListingSection } from "./ListingSection";

export interface ServicesProps {
  onAddService?: () => void;
  services: ListingCardListing[];
}

export function Services({ onAddService, services }: ServicesProps) {
  return (
    <ListingSection
      addLabel={t("components.views.shared.services.add_service")}
      addShortLabel={t("components.views.shared.services.add")}
      emptyDescription={t("components.views.shared.services.empty_description")}
      emptyIllustration={<Illustration name="open-soon" />}
      emptyTitle={t("components.views.shared.services.empty_title")}
      items={services}
      onAdd={onAddService}
      renderCard={(service) => <ListingCardAdapter key={service.sqid} listing={service} />}
      title={t("components.views.shared.services.title")}
    />
  );
}
